module.exports = __webpack_public_path__ + "media/alert-icon.fe1fcada.svg";